/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterStatSalesDto } from '../../models/center-stat-sales-dto';

export interface CenterStatControllerGetSalesStat$Params {
  year: string;
  centerId: string;
  type: string;
}

export function centerStatControllerGetSalesStat(http: HttpClient, rootUrl: string, params: CenterStatControllerGetSalesStat$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterStatSalesDto>>> {
  const rb = new RequestBuilder(rootUrl, centerStatControllerGetSalesStat.PATH, 'get');
  if (params) {
    rb.query('year', params.year, {});
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterStatSalesDto>>;
    })
  );
}

centerStatControllerGetSalesStat.PATH = '/api/center-stat/sales';
